<template>
  <order-list :is-order-status="30"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'UnpaidShipped',
  components: {
    OrderList
  }
}
</script>
